import React from 'react';
import ColumnsPopover from 'features/agent-analytics/components/ColumnsPopover';
import { CONFIGURABLE_SPAN_COLUMNS, DEFAULT_SPAN_COLUMN_KEYS } from 'features/agent-analytics/utils/spanColumns';

/**
 * Edit-columns control for the Spans table. Shares its popup with the Runs
 * table — see ColumnsPopover.
 */
export default function SpansColumnsButton({ columnKeys, onChange }) {
  return (
    <ColumnsPopover
      columns={CONFIGURABLE_SPAN_COLUMNS}
      columnKeys={columnKeys}
      defaultKeys={DEFAULT_SPAN_COLUMN_KEYS}
      onChange={onChange}
    />
  );
}
